var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"align":"center","justify":"center"}},[(_vm.patient)?_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('card-patient',{attrs:{"patient":_vm.patient}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }